import { RootState } from '../root.reducers';
import { TargetDomain } from './targetDomain.types';

export const getTargetDomainList = (state: RootState): TargetDomain[] => state.targetDomain.entities;

export const getSelectedTargetDomain = (state: RootState): TargetDomain[] => state.targetDomain.select;

export const getTargetDomain = (state: RootState): TargetDomain | null =>
  state.targetDomain.single;

export const getTargetDomainCreatedId = (state: RootState): string | null =>
  state.targetDomain.createdId;
